module.exports = __webpack_public_path__ + "static/media/trouser.5c679a0e.png";